import { createStore } from 'owa-satcheljs';

interface TestServiceStore {
    showTestService: boolean;
}

export const getStore: () => TestServiceStore = createStore<TestServiceStore>('testServiceStore', {
    showTestService: false,
});
